import request from '@/utils/request'

// 获取首页轮播图
export function getCategoryTree() {
  return request({
    url: 'app/category/getTree',
    method: 'get'
  })
}

// 获取栏目详情
export function getCategoryInfo(id) {
  return request({
    url: 'app/category/getOne/' + id,
    method: 'get'
  })
}

// 获取新闻列表
export function getContentList(params) {
  return request({
    url: 'app/content/queryList',
    method: 'get',
    params: params
  })
}

export function getContentInfo(id) {
  return request({
    url: 'app/content/queryOne/' + id,
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/content.js